import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";
import { StartResetPasswordResponse } from "@shared/apis/sidekick/generated";
import { useMutation } from "@tanstack/react-query";

type Props = {
  onSuccess: (data: StartResetPasswordResponse) => void;
  onError?: (error: any) => void;
};

type Params = {
  email: string;
};

export const useForgotPassword = (props: Props) => {
  const { onSuccess, onError } = props;
  const api = getAuthApiClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.authControllerStartResetPassword({
        startResetPasswordRequest: {
          email: params.email,
        },
      });
      onSuccess(response);
      return response;
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};
